<template>
  <div>
    <!-- PC端header -->
    <div :class="!isScroll_0 || whiteBg ? 'hHeader havaBg' : 'hHeader'">
    <!-- whiteBg -->
      <!-- 在线咨询 -->
      <el-dialog
        :visible.sync="dialogVisible"
        :append-to-body='true'
        :show-close='false'
        :lock-scroll="false"
        width="380px"
        >
        <div class="diaBox">
          <div class="diaClose">
            <i class="el-icon-close" @click="dialogVisible = false"></i>
          </div>
          <div class="diaInner">
            <img class="diaCode" src="../../assets/images/code.png" alt="">
            <p>扫码咨询在线客服</p>
          </div>
        </div>
      </el-dialog>
      <!-- 导航栏左侧logo -->
      <img class="logo" :src="!isScroll_0 || whiteBg ? logo2  : logo1" alt="" @click="goHome">
      <!-- 导航栏右侧文字 -->
      <div class="linkBox">
        <ul>
          <li v-for="(item,key) in list"  :key="key" @mouseenter="showTips(key)" @mouseleave="hideTips(key)" @click="toLink(item)">
            <a href="javascript:void(0);" :class="item.color ? 'haveColor' : ''">{{item.name}}</a>
            <transition name="el-zoom-in-center">
              <div v-show="item.isHover" :class="item.isHover ? 'underline transition-box' : ''"></div>
            </transition>
            <!-- 产品二级菜单 -->
            <el-collapse-transition>
              <div v-if="item.showChild && item.id == '2'" class="productBox">
              <div class="productLeft">
                <h4>迈格网络——新一代网络架构和NaaS创新领航者</h4>
                <div class="productWall">
                  <div>
                    <img src="../../assets/images/icon_01.png" alt="">
                    <p>迈格网络是自建自营的创新型智能网络服务平台</p>
                  </div>
                  <div>
                    <img src="../../assets/images/icon_02.png" alt="">
                    <p>迈格NaaS产品融合平台零信任安全、高弹性、高可观察性、人工智能运维等能力</p>
                  </div>
                  <div>
                    <img src="../../assets/images/icon_03.png" alt="">
                    <p>面向应用领域，提供合规和智能化网络服务！</p>
                  </div>
                  <div>
                    <img src="../../assets/images/icon_04.png" alt="">
                    <p>为互联网应用全生命期安全、稳定运行保驾护航！</p>
                  </div>
                </div>
              </div>
              <div class="productRight">
                <div class="productWall">
                  <div class="prodList" v-for="(items,keys) in item.articleList" :key="keys" @click="toLink(items,item.path,item.id)">
                    <img :src="items.coverImage" alt="">
                    <div>
                      <span>{{items.title }}</span>
                      <p>{{ items.description }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </el-collapse-transition>
            <!-- 解决方案二级菜单 -->
            <el-collapse-transition>
              <div v-if="item.showChild && item.id == '3'" class="planBox">
                <ul>
                  <li v-for="( itemi,keyi ) in item.articleList" :key="keyi" @click="toLink(itemi,item.path,item.id)">
                    <img :src="itemi.menuImg" alt="">
                    <div>
                      <strong>{{ itemi.title }}</strong>
                      <!-- <p>{{ itemi.description }}</p> -->
                    </div>
                  </li>
                </ul>
              </div>
            </el-collapse-transition>
            <!-- 社区开源二级菜单 -->
            <el-collapse-transition>
              <div v-show="item.showChild && item.id == '7'" class="outLink">
                <ul>
                  <li v-for="( itemk,keyk ) in item.linkList" :key="keyk" @click="openNewWeb(itemk.url)">
                    <img :src="itemk.img" alt="">
                    <p>{{ itemk.name }}</p>
                  </li>
                </ul>
              </div>
            </el-collapse-transition>
          </li>
        </ul>
        <div class="consult animate__animated animate__pulse" @click="consultClick">
          <a href="javascript:void(0);" class="comButton collection-1 btn-15"><span><i class="el-icon-phone-outline"/>   在线咨询</span></a>
        </div>
      </div>
    </div>
    <!-- 移动端header -->
    <div class="mobileHeader" >
      <img class="mobile_logo" :src="logo2" alt=""  @click="goHome">
      <div class="mobile_hr">
        <img class="callBt" src="../../assets/images/mobile_01.png" alt="" @click="consultClick">
        <img @click="showNavList" class="moreBt" :src="showNav ? mobile_img2 : mobile_img1" alt="">
      </div>
      <div class="navList" v-show="showNav">
        <ul>
          <li  v-for="(item,key) in list"  :key="key"  @click="toLink(item)">
            <!-- 一级菜单 -->
            <div class="li_parent" @click="showAllLi(key)">
              <p>{{ item.name }}</p>
              <i v-if="item.articleList && item.articleList.length > 0 && item.havechild === 1" :class="item.showAll ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
            </div>
            <!-- 二级菜单 -->
            <div v-show="item.showAll && item.havechild === 1" class="li_child" v-for="(items,keys) in item.articleList" :key="keys" @click="toLink(items,item.path,item.id)">
              <img :src="items.coverImage" alt="">
              <span>{{items.title }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// import { getlinks } from '@/service/servicePc'
export default {
  data () {
    return {
      pageTips: '',
      isScroll_0: true, // 判断滚轮是否到顶部
      logo1: require('../../assets/images/logo_01.png'), // logo白色
      logo2: require('../../assets/images/logo_02.png'), // logo蓝色
      list: [], // 一级导航数据
      dialogVisible: false, // 在线咨询开关
      whiteBg: false,
      thePath: Number,
      popupVisible: true,
      mobile_img1: require('../../assets/images/mobile_02.png'),
      mobile_img2: require('../../assets/images/mobile_03.png'),
      showNav: false
    }
  },
  methods: {
    // 监听滚轮
    handleScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      scrollTop === 0 ? this.isScroll_0 = true : this.isScroll_0 = false
    },
    // pc显示二级目录
    showTips (index) {
      this.list.forEach(item => {
        item.isHover = false
        item.showChild = false
      })
      this.list[index].isHover = true
      this.list[index].showChild = true
    },
    // pc隐藏二级目录
    hideTips (index) {
      this.list.forEach(item => {
        item.isHover = false
        if (item.path === this.thePath) {
          item.isHover = true
        }
        this.list[index].showChild = false
      })
    },
    // 点击在线咨询
    consultClick () {
      this.dialogVisible = true
    },
    // 获取导航数据ioo
    getNavList () {
      this.$axios.get('/blog/api/getcategorys')
        .then(res => {
          res.data.forEach((item, index) => {
            item.isHover = false
            item.showChild = false
          })
          res.data.forEach(item => {
            if (item.articleList.length > 0) {
              item.showAll = false
            }
          })
          this.list = res.data
          this.initNav()
        }).catch(err => {
          console.log(err)
        })
    },
    // 社区开源 打开新标签
    openNewWeb (url) {
      window.open(url, '_blank')
    },
    // 导航 点击跳转
    toLink (item, path, id) {
      if (item.id === 1) {
        this.$router.push('/')
        this.showNav = false
        return
      }
      if (item.havechild === 1) {
        return false
      }
      path ? this.$router.push({path: path, query: {id: id, childId: item.id}}) : this.$router.push({path: item.path, query: {id: item.id}})
      this.showNav = false
    },
    // 点击logo返回首页
    goHome () {
      this.$router.push('/')
      this.showNav = false
    },
    // 导航栏 初始化
    initNav () {
      this.thePath = this.$route.path
      this.list.forEach(item => {
        item.isHover = false
        if (item.path === this.$route.path) {
          item.isHover = true
        }
      })
      console.log(this.list)
    },
    // 移动端 点击展开导航
    showNavList () {
      this.showNav = !this.showNav
    },
    // 移动端 展开二级菜单
    showAllLi (index) {
      if (this.list[index].articleList.length === 0) {
        return
      }
      this.list[index].showAll = !this.list[index].showAll
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.id) { this.pageTips = this.$route.query.id }
    // 监听滚轮
    window.addEventListener('scroll', this.handleScroll, true)
    this.getNavList()
  },
  destroyed () {
    // 离开这个界面之后，删除滚动事件，不然容易除bug
    window.removeEventListener('scroll', this.handleScroll)
  },
  watch: {
    $route: {
      handler (newVal, oldVal) {
        this.initNav()
        let url = window.location.href
        if (url.indexOf('newsInfo') !== -1 || url.indexOf('getPlan') !== -1 || url.indexOf('declaration') !== -1) {
          this.whiteBg = true
        } else {
          this.whiteBg = false
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>

  // 移动端样式
@media only screen and (max-width: 1024px) {
  // el-dialog样式初始化
  /deep/ .el-dialog__body{
    padding: 0;
  }
  /deep/ .el-dialog__header{
    display: none;
  }
  .diaBox{
    background: url(https://a.perfma.net/fe/assets/4440563) no-repeat;
    background-size: cover;
    // 关闭按钮 X 样式
    .diaClose{
      height: 40px;
      text-align: right;
      font-size: 16px;
      padding: 12px;
      box-sizing: border-box;
      i{
        cursor: pointer;
      }
    }
    // 弹框内容样式
    .diaInner{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      padding: 20px 0;
      .diaLogo{
        width: 96px;
        height: 96px;
        margin-bottom: 24px;
      }
      .diaCode{
        width: 178px;
        height: 178px;
        margin-bottom: 16px;
      }
    }
  }
  .hHeader{
    display: none;
  }
  .mobileHeader{
    width:100%;
    height: 2.75rem;
    padding: 0 1.375rem;
    box-sizing: border-box;
    box-shadow: 0px 2px 12px 0px rgba(204,204,204,0.5);
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background: #fff;
    .mobile_logo{
      width: 5.5rem;
      height: 2rem;
    }
    .mobile_hr{
      display: flex;
      justify-content: center;
      align-items: center;
      .callBt{
        width: 5.6rem;
        height: 1.624rem;
        margin-right: 1.25rem;
      }
      .moreBt{
        width: 1.5rem;
        height: 1.5rem;
      }
    }
    .navList{
      position: absolute;
      top:2.75rem;
      left: 0;
      background: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100vh;
      overflow: scroll;
      ul{
        width: 100%;
        background: #fff;
        padding: 0 1.375rem;
        li{
          border-bottom: 1px solid #C9C9C9;
          .li_parent{
            font-size: 0.937rem;
            font-weight: bold;
            color: #353535;
            height: 3.44rem;
            line-height: 3.44rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            i{
              font-weight: bold;
              font-size: 1.25rem;
            }
          }
          .li_child{
            font-size: 0.875rem;
            font-weight: 400;
            display: flex;
            align-items: center;
            padding: 0.5rem 0;
            padding-left: 1.75rem;
            img{
              width: 1.5rem;
              height: 1.5rem;
              margin-right: 0.875rem;
            }
          }
        }
        li:last-child{
          border: 0;
        }
      }
    }
  }
}
// pc端样式
@media only screen and (min-width: 1024px) {
  .mobileHeader{
    display: none;
  }
  body{
    font-size:16px;
  }
  .comButton{
    color: #fff;
    border-radius: 0 28px 28px 28px;
    cursor: pointer;
    overflow: hidden;
    background-image: linear-gradient(228deg,#3EE3FF,#2E9EFD 41%,#186AE8);
    padding: 0;
    height:38px;
    font-size: 14px;
  }
  .btn-15:after{
    background-image: linear-gradient(315deg,#0027C2 0,#209DFF 74%);
  }
  // el-dialog样式初始化
  /deep/ .el-dialog__body{
    padding: 0;
  }
  /deep/ .el-dialog__header{
    display: none;
  }
  // 弹框样式
  .diaBox{
    background: url(https://a.perfma.net/fe/assets/4440563) no-repeat;
    background-size: cover;
    // 关闭按钮 X 样式
    .diaClose{
      height: 40px;
      text-align: right;
      font-size: 16px;
      padding: 12px;
      box-sizing: border-box;
      i{
        cursor: pointer;
      }
    }
    // 弹框内容样式
    .diaInner{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      padding: 20px 0;
      .diaLogo{
        width: 96px;
        height: 96px;
        margin-bottom: 24px;
      }
      .diaCode{
        width: 178px;
        height: 178px;
        margin-bottom: 16px;
      }
    }
  }
  .hHeader{
    display: block;
    position: fixed;
    width: 100%;
    height: 64px;
    padding: 0 80px;
    box-sizing: border-box;
    z-index: 99;
    display: flex;
    justify-content: space-between;
    align-items: center;
    top:0;
    // logo样式
    .logo{
      width: 137px;
      height: 50px;
      cursor: pointer;
    }
    .linkBox{
      display: flex;
      align-items: center;
      font-size: 16px;
      ul{
        display: flex;
        position: relative;
        li{
          position: relative;
          padding: 25px 20px;
          a{
            color: #fff;
          }
          // 产品二级菜单样式
          .productBox{
            width: 1200px;
            background: #fff;
            position: absolute;
            left: 50%;
            margin-top: 20px;
            margin-left: -600px;
            display: flex;
            text-align: left;
            box-shadow: 0 2px 12px 0 rgb(17 51 132 / 6%);
            border-radius: 5px;
            h4{
              width: 100%;
              margin-bottom: 24px;
            }
            a:hover{
              color: #346fff !important;
              cursor: pointer;
            }
            .productLeft{
              width: 506px;
              padding: 48px 65px;
              box-sizing: border-box;
              background: url('../../assets/images/img_nav.jpg') no-repeat;
              background-size: 100% 100%;
              border-radius: 5px 0 0 5px;
              h4{
                font-size: 16px;
                font-weight: 600;
                color: #08142A;
                line-height: 22px;
                margin-bottom: 46px;
              }
              .productWall{
                div{
                  display: flex;
                  margin-bottom:25px;
                  align-items: center;
                  color: #4C5461;
                  font-size: 13px;
                  img{
                    width: 37px;
                    height: 32px;
                    margin-right: 18px;
                  }
                  p{
                    font-size: 13px;
                    text-align: left;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display:-webkit-box;
                    -webkit-box-orient:vertical;
                    -webkit-line-clamp:2;
                  }
                }
              }
            }
            .productRight{
              width: 576px;
              padding: 32px 48px;
              box-sizing: border-box;
                color: #08142A;
              .productWall{
                font-size: 15px;
                font-weight: 600;
                .prodList{
                  display: flex;
                  margin-bottom: 40px;
                  cursor: pointer;
                  img{
                    width: 36px;
                    height: 36px;
                    margin-right: 22px;
                  }
                  div{
                    span{
                      font-size: 15px;
                      font-weight: 600;
                      color: #08142A;
                    }
                    p{
                      font-size: 13px;
                      font-weight: 300;
                      color: #4C5461;
                      margin-top: 11px;
                    }
                  }
                }
                .prodList:hover span{
                  color: #428BF8;
                }
              }
            }
          }
          // 解决方案二级菜单样式
          .planBox{
            width: 352px;
            background: #fff;
            position: absolute;
            left: 50%;
            margin-top: 20px;
            margin-left: -176px;
            padding: 32px 40px;
            box-sizing: border-box;
            box-shadow: 0 2px 12px 0 rgb(17 51 132 / 6%);
            border-radius: 5px;
            ul{
              display: block;
              li{
                width: 100%;
                display: flex;
                align-items: center;
                margin-bottom: 44px;
                padding: 0;
                img{
                  width: 32px;
                  height: 32px;
                  margin-right: 32px;
                }
                div{
                  cursor: pointer;
                  text-align: left;
                  strong{
                    font-size: 15px;
                    font-weight: bold;
                  }
                }
              }
              li:hover strong{
                color: #346fff;
              }
              li:last-child{
                margin: 0;
              }
            }
          }
          .outLink{
            width: 304px;
            border-radius: 5px;
            background: #fff;
            box-shadow: 0px 2px 12px 0px rgba(204,204,204,0.5);
            padding: 26px 40px;
            box-sizing: border-box;
            position: absolute;
            left: 50%;
            margin-top: 20px;
            margin-left: -152px;
            ul{
              display: flex;
              flex-direction: column;
              li{
                display: flex;
                align-items: center;
                cursor: pointer;
                padding: 0;
                margin-top: 24px;
                img{
                  width: 30px;
                  height: 30px;
                  margin-right: 28px;
                }
                p{
                  font-size: 15px;
                  font-weight: 600;
                  color: #08142A;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display:-webkit-box;
                  -webkit-box-orient:vertical;
                  -webkit-line-clamp:2;
                }
              }
              li:first-child{
                margin-top: 0;
              }
            }
          }
          // 加入我们二级菜单样式
          .joinBox{
            width: 170px;
            margin-left: -85px;
            li{
              strong{
                display: block;
                width: 100%;
                text-align: center !important;
              }
              strong:hover{
                cursor: pointer;
              }
            }
          }
        }
        .underline{
          position: absolute;
          bottom: 5px;
          left: 0;
          width: 100%;
          height: 3px;
          background: #428BF8;
          border-radius: 3px;
          transition: 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
        }
      }
      // 在线咨询样式
    }
  }
  // 导航栏变色样式
  .havaBg{
    background: #fff;
    .linkBox{
      ul{
        li{
          a{
            color: #353535;
          }
          a:hover{
            color: #346fff !important;
            cursor: pointer;
          }
          .haveColor{
            color: #346fff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comForPc/header.vue